/**
 * @tabler/icons-solidjs v2.32.0 - MIT
 */

import createSolidComponent from '../createSolidComponent.js';

var IconAngle = createSolidComponent("angle", "IconAngle", [
  ["path", { d: "M21 19h-18l9 -15" }],
  ["path", { d: "M20.615 15.171h.015" }],
  ["path", { d: "M19.515 11.771h.015" }],
  ["path", { d: "M17.715 8.671h.015" }],
  ["path", { d: "M15.415 5.971h.015" }]
]);

export { IconAngle as default };
//# sourceMappingURL=IconAngle.js.map
